"use strict";Object.defineProperty(exports, "__esModule", {value: true});





var _broadcastCampaign = require('shared/validation/broadcastCampaign');









 const makeDefaultValues = ({
  name, teamKey, senderKey, messageType, messageDelay,
}) => ({
  name: name || '',
  teamKey: (teamKey ) || '',
  senderKey: (senderKey ) || '',
  messageType: messageType || _broadcastCampaign.MessageType.SecureSMS,
  messageDelay: messageDelay || _broadcastCampaign.DEFAULT_MESSAGE_DELAY_MS,
}); exports.makeDefaultValues = makeDefaultValues
